import WJiyan from './JiYan';

WJiyan.install = (Vue) => {
  Vue.component(WJiyan.name, WJiyan);
};

export default WJiyan;
